import { render, staticRenderFns } from "./DeliveryWindow.vue?vue&type=template&id=4d15631a&"
import script from "./DeliveryWindow.vue?vue&type=script&lang=js&"
export * from "./DeliveryWindow.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryWindow.vue?vue&type=style&index=0&id=4d15631a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports